<script>
  export default {
    props: {
      type: {
        type: String,
        required: true,
      },

      label: {
        type: String,
        required: false,
      },

      value: {
        required: false,
      },

      floating: {
        type: Boolean,
        required: false,
        default: false,
      },
    },

    inheritAttrs: false,

    data: () => ({
      focus: false,
    }),
  };
</script>

<template>
  <div
    class="form-input"
    :class="{ 'form-input--focus': focus || value }"
    >
    <label
      v-if="label"
      v-text="label"
      class="form-input__label"
      @click="() => $refs.input.focus()"
      :class="{ 'form-input__label--floating': floating }"
      >
    </label>

    <input
      ref="input"
      :type="type"
      :value="value"
      v-bind="$attrs"
      @blur="focus = false"
      @focus="focus = true"
      class="form-input__control"
      @input="$emit('input', $event.target.value)"
      >
  </div>
</template>

<style lang="scss">
  .form-input {
    font-size: 13px;
    color: #b2b8c5;
    position: relative;
    margin-bottom: 24px;
    letter-spacing: 0.26px;

    * {
      transition: all 300ms;
    }

    &__label {
      display: block;
      padding: 0 16px 8px;

      &--floating {
        padding: 0 4px;
        margin-top: 16px;
        margin-left: 12px;
        position: absolute;
      }
    }

    &__control {
      outline: 0;
      width: 100%;
      padding: 16px;
      color: inherit;
      border-radius: 4px;
      border: 1px solid rgba(#FFF, 0);
      background-color: rgba(#FFF, .1);
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.2);

      &:hover {
        background-color: rgba(#FFF, .15);
      }
    }

    &--focus {
      color: #FFF;
    }

    &--focus & {
      &__label {
        &--floating {
          margin-top: -8px;
          background-color: #1c1e37;
        }
      }

      &__control {
        border: solid 1px #FFF;
        background-color: rgba(#FFF, 0);
      }
    }
  }
</style>

